import { __assign } from '../../../../../../tslib/tslib.es6.js';
import { number } from '../../../../../../style-value-types/dist/es/numbers/index.mjs.js';

var int = __assign(__assign({}, number), { transform: Math.round });

export { int };
